<template>
    <v-dialog
        v-model="dialog"
        :max-width="dialog_width"
        :persistent="saveLoading"
    >
        <div class="tw-flex tw-flex-col side-site-padding tw-gap-2">
            <h2 class="tw-capitalize tw-text-secondary">
                {{ mode }} Crew
            </h2>
            <v-form name="editForm" ref="editForm">
                <div class="tw-flex tw-flex-row tw-gap-4 tw-w-full">
                    <!-- Member Selection -->
                    <v-autocomplete
                        v-model="modelObject.user_id"
                        :items="members"
                        label="Member"
                        outlined
                        class="tw-w-2/3"
                        :loading="isLoading"
                        :disabled="isLoading"
                        :rules="[rules.required]"
                    ></v-autocomplete>
                    <!-- Member ID Text Field -->
                    <v-text-field
                        v-model="modelObject.user_id"
                        label="Member ID"
                        outlined
                        readonly
                        class="tw-w-1/3"
                    ></v-text-field>
                </div>
                <!-- Print Notes Textbox -->
                <v-text-field
                    v-model="modelObject.note"
                    label="Print Notes"
                    outlined
                ></v-text-field>
                <!-- Non-Print Notes Textbox -->
                <v-text-field
                    v-model="modelObject.note_private"
                    label="Non-Print Notes"
                    outlined
                ></v-text-field>

                <!-- Start Date Datepicker -->
                <div class="tw-flex tw-flex-row tw-gap-4 tw-w-full">
                    <date-picker
                        v-model="modelObject.date_start"
                        ref="datePicker"
                        display-label="Start Date"
                        outlined
                        class="tw-w-1/2"
                        :rules="[rules.required]"
                    ></date-picker>

                    <!-- Stop Date Datepicker -->
                    <date-picker
                        v-model="modelObject.date_stop"
                        ref="datePicker2"
                        display-label="Stop Date"
                        outlined
                        class="tw-w-1/2"
                        :rules="[rules.required]"
                    ></date-picker>
                </div>
                <!-- Function Selection -->
                <v-autocomplete
                    v-model="modelObject.title_function_id"
                    :items="valuelist.TITLE_FUNCTIONS"
                    label="Function"
                    autocomplete
                    clearable
                    outlined
                    :rules="[rules.required]"
                ></v-autocomplete>
                <!-- Camera Dropdown -->
                <div class="tw-flex tw-flex-row tw-gap-4 tw-w-full">
                    <v-select
                        v-model="modelObject.camera"
                        :items="cameraOptions"
                        label="Camera"
                        outlined
                        :rules="[rules.required]"
                    ></v-select>

                    <!-- Unit Dropdown -->
                    <v-select
                        v-model="modelObject.unit"
                        :items="unitOptions"
                        label="Unit"
                        outlined
                        :rules="[rules.required]"
                    ></v-select>
                </div>
                <div class="tw-flex tw-flex-row tw-gap-4 tw-w-full">
                    <!-- Include in Report Checkbox -->
                    <v-checkbox
                        v-model="modelObject.include_in_report"
                        label="Include in Report"
                        outlined
                        class="tw-w-1/2 tw-pb-4"
                        false-value="0"
                        true-value="1"
                    ></v-checkbox>
                <!-- Priority Number Input -->
                    <v-text-field
                        v-model="modelObject.priority"
                        label="Priority"
                        type="number"
                        hide-details
                        clearable
                    ></v-text-field>
                </div>
            </v-form>
            <div class="tw-flex tw-flex-row tw-justify-center tw-gap-3">
                <v-btn
                    text
                    @click="cancelDialog"
                    class="main-btn"
                >
                    Cancel
                </v-btn>
                <v-btn
                    text
                    @click="archiveProductionCrew()"
                    class="main-btn"
                    :loading="archiveLoading"
                    v-show="is_edit_mode"
                >
                    Delete
                </v-btn>
                <v-btn
                    text
                    @click="saveModel"
                    class="main-btn"
                    :loading="saveLoading"
                >
                    Save
                </v-btn>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import DatePicker from "@/Generic/DatePicker";

export default {
    name: "EditProductionCrewModal",
    components: {
        DatePicker,

    },
    props: {
        'value': {
            // The visibility of the dialog.  To be used with `v-model`
            required: true
        },
        'modelProp': {
            // The model we want to show details for (model is generic and don't require to be modified for each reuse of this modal)
            type: Object,
            required: false
        },
        'constants': {
            // The constants we will rely on
            type: Object,
            required: true
        },
        'valuelists': {
            type: Object,
            required: false
        },
        'productionId': {
            // The model we want to show details for (model is generic and don't require to be modified for each reuse of this modal)
            type: Number,
            required: false
        },
        'members': {
            // The valuelist of members we will rely on
            type: Array,
            required: false,
            default: function () {
                return undefined
            }
        },
    },
    data() {
        return {
            dialog: this.value || false,
            production_id: this.productionId || '',
            valuelist: this.valuelists,
            mode: 'Add',
            errors: null,
            modelObject: this.modelProp || {},
            modelDefault: {
                id: null,
                include_in_report: null,
                priority: undefined,
            },
            saveLoading: false,
            rules: {
                required: value => !!value || 'Required',
                integer: value => /^(\s*|\d+)$/.test(value) || `Value must only include numbers`,

            },
            archiveLoading: false,
            cameraOptions: [
                {text: 'A',         value: 'A'},
                {text: 'B',         value: 'B'},
                {text: 'C',        value: 'C'},
                {text: 'D',        value: 'D'},
            ],
            unitOptions: [
                {text: 'Main',         value: 'Main'},
                {text: 'Second Unit',         value: 'Second Unit'},
            ],
            isLoading: true,
        }
    },
    mounted() {

    },
    computed: {
        dialog_width() {
            return '40%'
        },
        is_edit_mode() {
            return this.mode == 'Edit' ? true : false
        }
    },
    methods: {
        validateEndDate() {
            if (this.modelObject.date_start && this.modelObject.date_stop) {
                const startDate = new Date(this.modelObject.date_start)
                const endDate = new Date(this.modelObject.date_stop)

                if (endDate <= startDate) {
                    this.errors = {
                        date_stop: 'End date must be after start date.'
                    }
                } else {
                    this.errors = null
                }
            }
        },

        loadCrewDetails() {
            if (this.modelProp === null) {
                this.mode = 'Add'
                this.modelObject = structuredClone(this.modelDefault)
            } else {
                this.mode = 'Edit'
                this.modelObject = structuredClone(JSON.parse(JSON.stringify(this.modelProp)))
            }
        },

        activeOption(option) {
            if( this.activeOptions.includes(option) ){
                return true
            }
            return false
        },
        resetModel() {
            this.modelObject = structuredClone(this.modelDefault)
        },
        resetForm() {
            this.modelObject = structuredClone(this.modelDefault)
            this.$refs.editForm.resetValidation()
        },
        cancelDialog() {
            if (!this.loading) {
                this.dialog = false
                this.resetForm()
            }
        },
        saveModel() {
            let payload = this.modelObject

            if (!this.$refs.editForm.validate()) {
                this.$root.snackbar.error('Please fill all required fields.')
                return false
            }

            const startDate = new Date(this.modelObject.date_start)
            const endDate = new Date(this.modelObject.date_stop)

            if (endDate <= startDate) {
                this.$root.snackbar.error('End date must be after the start date.')
                return false
            }

            let url = ''

            if (this.is_edit_mode) {
                url = route('productioncrews.update', this.modelObject.id)
                payload._method = "patch"
            } else {
                url = route('productioncrews.store')
                payload.production_id = this.production_id
            }

            axios({
                method: 'post',
                url: url,
                data: payload,
                onUploadProgress: (evt) => {
                    this.saveLoading = !this.saveLoading
                },
                onDownloadProgress: (evt) => {
                    this.saveLoading = !this.saveLoading
                },
            })
                .then(response => {
                    if (response.data.success) {
                        this.$root.is_dirty = false
                        this.$root.snackbar.success('Changes have been saved')
                        this.dialog = false
                        this.$root.is_dirty = false
                        this.saveLoading = false
                        this.$emit('successful-save')

                    } else if (response.data?.error) {
                        throw (response.data?.error)
                    } else {
                        throw ('Unknown error.')
                    }
                })
                .catch((error) => {
                    this.saveLoading = false
                    this.$root.handleError(error)
                });
        },


        async archiveProductionCrew()
        {
            if (await this.$root.confirm.open(`Delete Production Crew Member`, `You are about to delete member ${this.modelObject.user_id}`)) {

                let method = 'delete'
                let url = route('productioncrews.destroy', this.modelObject.id)

                axios({
                    method: method,
                    url: url,
                    data: this.modelObject,
                    onUploadProgress: (evt) => {
                        this.archiveLoading = !this.archiveLoading
                    },
                    onDownloadProgress: (evt) => {
                        this.archiveLoading = !this.archiveLoading
                    },
                })
                    .then(response => {
                        if (response.data.success) {
                            this.$root.is_dirty = false
                            this.$root.snackbar.success('Production Crew member has been deleted')
                            this.dialog = false
                            this.$root.is_dirty = false
                            this.archiveLoading = false
                            this.$emit('successful-save')
                        } else {
                            throw (response.data.error)
                        }
                    })
                    .catch((error) => {
                        this.$root.snackbar.error(error.response.data.message)
                        this.archiveLoading = false
                    })
            }
        },

    },
    watch: {
        value(newInput, oldInput) {
            this.dialog = newInput;

            if (newInput) {
                this.loadCrewDetails();
            } else {
                this.resetForm();
            }
        },
        dialog(newDialog, oldDialog) {

            this.$emit('input', newDialog)
            if (newDialog === false) {
                // Closing modal
                this.activeEditor1 = false
                this.$refs.editForm.reset()
            } else {
                // Opening modal
                if (this.modelProp === null) {
                    this.mode = 'Add'
                    this.modelObject = structuredClone(this.modelDefault)
                } else {
                    this.mode = 'Edit'
                    this.modelObject = structuredClone(JSON.parse(JSON.stringify(this.modelProp)))
                }
            }
        },
        'modelObject.date_start'(newDate) {
            if (typeof this.$refs.datePicker !== 'undefined'){
                this.$refs.datePicker.date_temp = newDate
                this.validateEndDate()
            }
        },

        'modelObject.date_stop'(newDate) {
            if (typeof this.$refs.datePicker2 !== 'undefined'){
                this.$refs.datePicker2.date_temp = newDate
                this.validateEndDate()
            }
        },
        'members'() {
            this.isLoading = false
        },
        'modelObject.title_function_id'(newValue) {
            let title_function = this.valuelists.TITLE_FUNCTIONS.find(tf => tf.value === newValue)
            let default_camera = title_function?.default_camera
            console.log(default_camera)
            if (!!default_camera && !this.modelObject.camera){
                console.log("Updating")
                this.modelObject.camera = default_camera
            } else if (!!default_camera && (this.modelObject.camera !== default_camera)){
                console.log("Skipping update")
                this.$root.snackbar.warning(`This function is usually camera ${default_camera}`)
            }
        }
    },
}
</script>
<style scoped>
</style>
